export default __webpack_public_path__ + "static/media/InfoPhoneLogo.c219396e.svg";